module.exports={
    INIT_APP: 'INIT_APP'
}